import React from "react";
import Loadable from "react-loadable";
import PageLoader from "../components/PageLoader";

export const Accounts = Loadable({
  loader: () => import("../modules/Accounts/Profile"),
  loading: PageLoader,
});

export const DiyDashboard = Loadable({
  loader: () => import("../modules/DiyDashboard"),
  loading: PageLoader,
});

export const BrandVerifications = Loadable({
  loader: () => import("../modules/BrandVerifications"),
  loading: PageLoader,
});

// export const Awards = Loadable({
//   loader: () => import("../modules/Awards"),
//   loading: PageLoader,
// });

// export const AwardsCreate = Loadable({
//   loader: () => import("../modules/Awards/AddEditAward"),
//   loading: PageLoader,
// });

// export const ViewCampaign = Loadable({
//   loader: () => import("../modules/Awards/ViewCampaign"),
//   loading: PageLoader,
// });

// export const BrandVoucherList = Loadable({
//   loader: () => import("../modules/ClientDashboard/BrandVoucherList"),
//   loading: PageLoader
// });

// export const SitesList = Loadable({
//   loader: () => import("../modules/Sites/SitesList"),
//   loading: PageLoader
// });

export const Recharge = Loadable({
  loader: () => import("../modules/Recharge"),
  loading: PageLoader,
});

// export const GenerateBrandVoucher = Loadable({
//   loader: () => import("../modules/ClientDashboard/GenerateBrandVoucher"),
//   loading: PageLoader,
// });

export const PlumPro = Loadable({
  loader: () => import("../modules/PlumPro"),
  loading: PageLoader,
});

export const ListingBrandVouchers = Loadable({
  loader: () => import("../modules/ClientDashboard/ListingBrandVouchers"),
  loading: PageLoader,
});

export const VoucherRecharge = Loadable({
  loader: () => import("../modules/Reports/VoucherRecharge"),
  loading: PageLoader,
});

export const PlumProReport = Loadable({
  loader: () => import("../modules/Reports/PlumProReport"),
  loading: PageLoader,
});

export const EmpulsReport = Loadable({
  loader: () => import("../modules/Reports/EmpulsReport"),
  loading: PageLoader,
});

export const Report = Loadable({
  loader: () => import("../modules/Reports"),
  loading: PageLoader,
});

export const PerksReport = Loadable({
  loader: () => import("../modules/Reports/PerksReport"),
  loading: PageLoader,
});

// export const XoxoCode = Loadable({
//   loader: () => import("../modules/XoxoCode"),
//   loading: PageLoader,
// });

export const XoxoCodeNew = Loadable({
  loader: () => import("../modules/XoxoCodeNew"),
  loading: PageLoader,
});

export const DiwaliGifting = Loadable({
  loader: () => import("../modules/DiwaliGifting"),
  loading: PageLoader,
});

export const XoxoPointsNew = Loadable({
  loader: () => import("../modules/XoxoPointsNew"),
  loading: PageLoader,
});

// export const PlumPoints = Loadable({
//   loader: () => import("../modules/PlumPoints"),
//   loading: PageLoader,
// });

export const BulkUpload = Loadable({
  loader: () => import("../components/BulkUpload"),
  loading: PageLoader,
});

export const Campaign = Loadable({
  loader: () => import("../modules/Campaign"),
  loading: PageLoader,
});

export const XoxoLinkCampaign = Loadable({
  loader: () => import("../modules/Campaign/XoxoLinkCampaign"),
  loading: PageLoader,
});

export const XoxoCodeCampaign = Loadable({
  loader: () => import("../modules/Campaign/XoxoCodeCampaign"),
  loading: PageLoader,
});

export const Wallet = Loadable({
  loader: () => import("../modules/Wallet"),
  loading: PageLoader,
});

export const XoxoTokenReport = Loadable({
  loader: () => import("../modules/Reports/XoxoTokenReports"),
  loading: PageLoader,
});

export const PlatformPreferences = Loadable({
  loader: () => import("../modules/Accounts/PlatformPreferences"),
  loading: PageLoader,
});

export const Profile = Loadable({
  loader: () => import("../modules/Accounts/Profile"),
  loading: PageLoader,
});

export const Funds = Loadable({
  loader: () => import("../modules/Accounts/Funds"),
  loading: PageLoader,
});

export const ActivityLog = Loadable({
  loader: () => import("../modules/Accounts/ActivityLog"),
  loading: PageLoader,
});
// export const XoxoLink = Loadable({
//   loader: () => import("../modules/XoxoLink"),
//   loading: PageLoader,
// });
export const XoxoLinkNew = Loadable({
  loader: () => import("../modules/XoxoLinkNew"),
  loading: PageLoader,
});
export const Integrations = Loadable({
  loader: () => import("../modules/Integrations"),
  loading: PageLoader,
});

export const EmailPreviewScreen = Loadable({
  loader: () => import("../modules/EmailPreviewScreen/emailPreviewIndex"),
  loading: PageLoader,
});
export const XoxolinkEmailPreview = Loadable({
  loader: () => import("../modules/EmailPreviewScreen/xoxolinkEmailPreview"),
  loading: PageLoader,
});
export const IntegrationsDashboard = Loadable({
  loader: () => import("../modules/IntegrationsDashboard"),
  loading: PageLoader,
});
export const SapSuccessfactors = Loadable({
  loader: () => import("../modules/SapSuccessfactors"),
  loading: PageLoader,
});
export const Darwin = Loadable({
  loader: () => import("../modules/Darwin"),
  loading: PageLoader,
});

export const PublicLogin = Loadable({
  loader: () => import("../components/PublicLogin"),
  loading: PageLoader,
});

export const AutomationCreation = Loadable({
  loader: () => import("../modules/Integrations/automationCreation"),
  loading: PageLoader,
});

export const AutomationDetails = Loadable({
  loader: () => import("../modules/Integrations/automationDetails"),
  loading: PageLoader,
});

export const AutomationSuccess = Loadable({
  loader: () => import("../modules/Integrations/AutomationSuccess"),
  loading: PageLoader,
});

export const Templates = Loadable({
  loader: () => import("../modules/Templates"),
  loading: PageLoader,
});
